import { hotjar } from 'react-hotjar';

export const initializeHotjar = () => {
    hotjar.initialize(parseInt(process.env.GATSBY_HOTJAR_ID), 6);
}